import React from 'react';
import AttachmentButtonDownload from "../blocks/buttons/download";
import {AttachFileMode} from "../../const";
import Attachment from "../../../../model2/attachment/attachment";
import AttachmentButtonOpenNewWindow from "../blocks/buttons/open-new-window";
import AttachmentButtonPreview from "../blocks/buttons/preview";

// const debug = "AttachmentViewNoPreviewSmall"
const debug = false

type Props = {
    attachment        : Attachment
    mode              : AttachFileMode
    onPreview?        : callback
    onRemove?         : callback
    onAddToMessage?   : callback
    showRemoveButton? : boolean;
}

export default function AttachmentViewNoPreviewSmall(props: Props) {

    debug && console.log(debug, "render()", props)

    const onRemoveClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onRemove) props.onRemove(props.attachment)
    }

    const onPreviewClick = () => {
        if(props?.onPreview){
            props.onPreview(props.attachment);
        }
    }

    const {attachment} = props;

    return (
        <div className="ui5-attachment-no-preview-small">
            <div className="preview">
                <div className="ui5-ico-14 i5-attachment" />
            </div>
            <div className="details">
                <div className="file-name ui5-txt-less-important-tiny txt-truncate">
                    {props.attachment.name}
                </div>
            </div>

            {(props.mode === AttachFileMode.VIEW_SMALL || props.mode === AttachFileMode.VIEW_IN_EDITOR_SMALL) &&
                <div className="overlay-details">
                    <div className="file-size ui5-txt-not-important-tiny">
                        {props.attachment.fileSizeFormatted}
                    </div>
                    <div className="actions">
                        <AttachmentButtonDownload attachment = {props.attachment}/>
                        {props.attachment.previewAvailable && (
                            <>
                                <AttachmentButtonOpenNewWindow attachment   = {attachment}
                                                               className    = "m-r-5"/>
                                <AttachmentButtonPreview attachment     = {attachment}
                                                         onPreviewClick = {onPreviewClick} />
                            </>
                        )}
                    </div>
                </div>
            }

            {(props.mode === AttachFileMode.VIEW_AND_EDIT_SMALL) &&
                <div className="overlay-details">
                    <div className="file-size ui5-txt-not-important-tiny">
                        {props.attachment.fileSizeFormatted}
                    </div>
                    <div className="actions">
                        <div className="ui5-ico-round red i5-trash-alt m-r-5" onClick={onRemoveClick} />
                        <AttachmentButtonDownload attachment   = {props.attachment}
                                                  className    = "m-r-5"/>
                        {props.attachment.previewAvailable && (
                            <>
                                <AttachmentButtonOpenNewWindow attachment   = {attachment}
                                                               className    = "m-r-5"/>
                                <AttachmentButtonPreview attachment     = {attachment}
                                                         onPreviewClick = {onPreviewClick} />
                            </>
                        )}
                    </div>
                </div>
            }

        </div>
    )
}
